import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorStoreAccountList = () => {
  const storeAccountList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/store-account/list', payload, response => {
      if (response.status_code === 200) {
        callback(response.data)
      }
    })
  }, [])

  return { storeAccountList }
}

export default InteractorStoreAccountList
